import styled from 'styled-components';

import Tick from 'components/Icons/Tick';
import colors from 'utils/colors';
import device from 'utils/device';

export type ItemMode = 'Current' | 'Past' | 'Future';

export interface ItemProps {
  /**
   * Mode the step is at (active step, future step in the workflow or earlier/completed step in the workflow)
   */
  mode: ItemMode;
}

export interface LineProps {
  /**
   * the height of the divider line (for Desktop mode)
   */
  height: number;
}

const BaseWrapper = styled.div``;

export const Wrapper = styled(BaseWrapper)`
  @media ${device.isDesktop} {
    margin-right: 64px;
  }

  @media ${device.isMobile}, ${device.isTablet} {
    border-bottom: solid 1px ${colors.blueGrey25};
  }
`;

export const Box = styled(BaseWrapper)`
  @media ${device.isDesktop} {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

export const StepsLineContainer = styled(BaseWrapper)<LineProps>`
  position: relative;

  @media ${device.isDesktop} {
    display: flex;
    align-self: flex-start;
    left: 40px;
    padding-top: 37px;
    height: ${props => `${props.height}px;`};
  }

  @media ${device.isMobile}, ${device.isTablet} {
    top: 36px;
    left: 20px;
    right: 20px;
    width: calc(100% - 40px);
  }
`;

export const StepLine = styled(BaseWrapper)`
  border: solid 1px ${colors.orange};
`;

export const ListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  border-radius: 2px;
  background-color: ${colors.white};

  @media ${device.isDesktop} {
    border: solid 1px ${colors.orange};
    width: 200px;
    margin-top: 0px;
    padding: 32px 20px 40px 20px;
  }

  @media ${device.isMobile}, ${device.isTablet} {
    flex-direction: row;
    padding-left: 20px;
    padding-right: 20px;
    justify-content: space-between;
    align-items: center;
  }
`;

export const ItemContainer = styled.li<ItemProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  @media ${device.isDesktop} {
    margin-bottom: 33px;
  }
`;

export const IconWrapper = styled(BaseWrapper)<ItemProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 32px;
  min-height: 32px;
  border: solid 2px ${colors.orange};
  border-radius: 100px;
  font-size: 19px;
  z-index: 2;
  color: ${colors.white};
  font-weight: bold;
  background-color: ${props =>
    props.mode === 'Current' || props.mode === 'Past' ? colors.orange : colors.white};
  color: ${props =>
    props.mode === 'Current' || props.mode === 'Past' ? colors.white : colors.orange};
`;

export const CompletedStepWrapper = styled(Tick)`
  width: 20px;
  height: 20px;
`;

export const TextWrapper = styled(BaseWrapper)<ItemProps>`
  white-space: pre-wrap;
  word-break: break-word;
  overflow: hidden;
  margin-left: 12px;
  letter-spacing: -0.3px;
  line-height: 22px;
  max-height: 44px;
  min-height: 22px;
  color: ${props => (props.mode === 'Current' ? colors.orange : colors.blueGrey)};
  font-weight: ${props => (props.mode === 'Current' ? 'bold' : '600')};
  font-size: ${props => (props.mode === 'Current' ? '19px' : '1.1rem')};

  @media ${device.isMobile}, ${device.isTablet} {
    display: none;
  }
`;
